import { ScanQrTicketReaderComponent } from "./scan-qr-ticket-reader/scan-qr-ticket-reader.component";

export const COMPONENTS = [
  ScanQrTicketReaderComponent
];
